const evidence = {
  title: '根拠',
  empty: 'この指摘に紐づく根拠はまだありません。',
  error: '根拠を読み込めませんでした。時間をおいて再度お試しください。',
  noAnchor: 'アンカーなし',
  copyReference: '参照情報をコピー',
  pageUnknown: '正確な位置は記録されていません。文書を開いて確認してください。',
  unversioned: '版なし',
  retrievedAt: '取得日時',
  sourceRevision: 'ソース版',
  generatorVersion: '生成器バージョン',
  openPage: '{{page}}ページを開く',
  openDocument: '文書を開く',
  missingRevisionContext: 'この指摘には対象版の情報がないため、根拠を取得できません。',
  errorPermanent: 'この指摘の根拠は取得できません。設定または対象データを確認してください。',
  unrenderable: 'この指摘は生成器バージョンを持たないため、根拠を表示できません。',
  loading: '根拠を読み込んでいます…',
  notCarried: '根拠に変換できなかった項目',
  conversionNote: {
    missing_source_revision: 'ソース版の情報がないため、版を固定できません。',
    unsupported_locator: '遷移先を特定できる位置情報がありません。',
    unsupported_source_type: 'この種類のソースは根拠として扱えません。',
    unknown: '理由を判別できませんでした。',
  },
  copied: '参照情報をコピーしました。',
  copyFailed: 'コピーできませんでした。手動で選択してください。',
  status: {
    unverified: '未検証',
    verified: '検証済み',
    missing: '根拠なし',
    stale: '版が古い',
    unsupported: '根拠が未対応',
    conflict: '根拠が矛盾',
    withheld: '根拠を表示できません',
    unknown: '状態不明',
  },
  sourceType: {
    document_page: '文書ページ',
    standard_clause: '規格',
    past_trouble: '過去トラブル',
    geometry_calculation: '幾何計算',
    unknown: '種類不明のソース',
    model_output: 'モデル出力',
  },
  reason: {
    permissionDenied: 'この根拠の位置情報を閲覧する権限がないため、遷移できません。',
    sourceDeleted: '参照先の文書は削除されています。',
    unsupportedLocator: 'ソースが文書を指していないため、遷移先を特定できません。',
    unsupportedSourceType: 'この種類のソースはアプリ内に遷移先がありません。',
  },
  availability: {
    partially_unavailable: '一部の根拠を開けません',
    unavailable: '根拠を開けません',
  },
  contractMismatch: 'サーバーから返された根拠データをこの画面では解釈できません。管理者に連絡してください。',
  errorPermissionDenied: 'この指摘の根拠を閲覧する権限がありません。',
  missingRetrievalTime: 'この指摘には作成日時がないため、根拠の取得時刻を記録できません。',
  anchorMaturity: {
    unknown: '成熟度不明のアンカー',
    no_anchor: 'アンカーなし',
    candidate_anchor: 'AI候補アンカー',
    manual_anchor: '手動アンカー',
    verified_anchor: '検証済みアンカー',
    rejected_anchor: '却下されたアンカー',
    stale_anchor: '版が古いアンカー',
    superseded_anchor: '置き換えられたアンカー',
  },
};

export default evidence;
